import { Theme } from '@mui/material'

const borderRadiusTransitionDelay = '100ms'
const useStyles = {
  searchTextInputRoot: (theme: Theme) => ({
    boxShadow: theme.shadows[0],
  }),
  mainPaper: (theme: Theme) => ({
    padding: theme.spacing(2),
    position: 'relative',
    borderRadius: theme.shape.extraLargeBorderRadius,
    boxShadow: theme.shadows[4],
    '&:focus-within': {
      transition: `${theme.transitions.create('box-shadow')},
                     ${theme.transitions.create('border-radius', { duration: borderRadiusTransitionDelay })}`,
      borderRadius: theme.spacing(4, 4, 0, 0),
      boxShadow: theme.shadows[4],
    },
    '&:focus-within > #secondaryPaper': {
      maxHeight: '800px',
      transition: `${theme.transitions.create('max-height', { duration: 750, easing: theme.transitions.easing.sharp, delay: borderRadiusTransitionDelay })},
                     ${theme.transitions.create('box-shadow')},
                     ${theme.transitions.create('padding', { delay: borderRadiusTransitionDelay })}`,
      borderTop: `1px solid ${theme.palette.divider}`,
      padding: theme.spacing(0, 0, 4, 0),
      boxShadow: theme.shadows[4],
      // this clipPath removes the shadow from the top of the dropdown paper
      clipPath: 'inset(0px -10px -10px -10px)',
    },
  }),
  secondaryPaper: (theme: Theme) => ({
    zIndex: 5,
    position: 'absolute',
    left: 0, // the parent's padding messes with the alignment of the absolute positioned paper, this readjusts it.
    top: theme.spacing(8), // this also readjusts, might be weird values depending on parents padding
    width: '100%',
    maxHeight: '0px',
    overflow: 'hidden',
    borderRadius: theme.spacing(0, 0, 1, 1),
    boxShadow: theme.shadows[0],
    transition: 'none',
  }),
  searchTypeButton: (theme: Theme) => ({
    borderRight: `1px solid ${theme.palette.action.selected}`,
    borderRadius: 0,
    padding: theme.spacing(0, 2, 0, 3),
    margin: theme.spacing(0, 2, 0, -2),
    height: theme.spacing(8),
  }),
  searchTypeCheckIcon: (theme: Theme) => ({
    fontSize: '20px',
    marginLeft: theme.spacing(1),
  }),
  resultsContainer: {
    maxHeight: 'calc(100vh - 400px)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  hasMoreResultsContainer: (theme: Theme) => ({
    backgroundColor: theme.palette.grey[50],
    height: '36px',
  }),
  section: (theme: Theme) => ({
    padding: theme.spacing(2, 2),
  }),
  resultType: {
    fontWeight: 500,
  },
  searchMenuItemIcon: (theme: Theme) => ({
    color: theme.palette.text.disabled,
  }),
  searchItemIcon: (theme: Theme) => ({
    color: theme.palette.text.disabled,
    marginRight: theme.spacing(1),
  }),
  searchItemPrimaryTextCaption: (theme: Theme) => ({
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(-0.5),
  }),
  searchItemSecondaryTextIcon: (theme: Theme) => ({
    fontSize: theme.typography.fontSize,
    marginBottom: theme.spacing(-0.25),
    marginRight: theme.spacing(0.5),
  }),
  removeBottomSpace: (theme: Theme) => ({
    marginBottom: theme.spacing(-4),
  }),
  resultItemTextContainer: (theme: Theme) => ({
    width: '100%',
    paddingRight: theme.spacing(3),
  }),
}

export default useStyles
